import { MaintenanceInfo } from '../types/maintenance';

/**
 * メンテナンス情報を取得する
 *
 * API サーバではなくコンテンツサーバに置かれている JSON ファイルを取得するので RTK Query は使用しない。
 *
 * @returns maintenanceInfo
 */
export const getMaintenanceInfo = async () =>
  fetch('/maintenance.json')
    .then((res) => res.json())
    // fetch API のレスポンス型は any の状態なので as による型設定を許容する
    .then((data) => data as MaintenanceInfo);
